import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getReportsFinanceByServices(options = {}) {
  return _apiRequestWrap(
    ModulesMap.REPORTS_FINANCE_BY_SERVICES,
    ModulesConfigMap[ModulesMap.REPORTS_FINANCE_BY_SERVICES].GET_REPORTS_FINANCE_BY_SERVICES,
    options
  )
}

export default {
  [ModulesConfigMap[ModulesMap.REPORTS_FINANCE_BY_SERVICES].GET_REPORTS_FINANCE_BY_SERVICES]: _getReportsFinanceByServices,
}